import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changePassword, setPassword } from "@/api/authNew";
import { accountsQueryKeys } from "@/tanstackQuery/queries";
import { toast } from "sonner";

export const useChangePassword = () => {
  return useMutation({
    mutationFn: changePassword,
    onSuccess() {
      toast("Your password has been changed");
    },
  });
};

export const useSetPassword = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setPassword,
    onSuccess(res) {
      queryClient.invalidateQueries({
        queryKey: [accountsQueryKeys.list],
      });
      if (res.message) toast(res.message);
    },
  });
};
